import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import DigitalTransformationDetails from '../../subdepartmentdetails/DigitalTransformation'


function DigitalTransformation() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Digital Transformation and Smart City Projects || Innovation and Technology";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Innovation Technology"
            title="Digital Transformation"
            subtitledown="Department of Innovation & Technology"
           />
            <DigitalTransformationDetails/>
        </div>
    </>
  )
}

export default DigitalTransformation